
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import {
  ServerInterface,
  ServerRepositoryInterface,
} from '@/services/Server/Interfaces';

@Component({
  mixins: [Themeable],
  inject: ['serverRepository'],
})
export default class ServersDialog extends Vue {
  public visible: boolean = true;

  public loading = true;

  private serverRepository!: ServerRepositoryInterface;

  public servers: ServerInterface[] = [];

  public selectedServer: string = '';

  public async created(): Promise<void> {
    try {
      this.servers = await this.serverRepository.getAllServers();
      this.loading = false;
    } catch (err) {
      this.$errorDialog.show(err.response?.data?.message || err.message);
    }
  }

  public update(): void {
    this.$emit('updateServerIps', this.selectedServer);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
